import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Item from "../../../containers/modules/master/item";
import ViewItem from "./item/view";

export default function ItemRoute(props) {
  const { authUser } = props;
  return (
    <Route path="item">
      <Route
        index
        element={
          <AccessControl
            name={"Item List"}
            auth={authUser}
            component={() => <Item authUser={authUser} />}
          />
        }
      />
      <Route
        path="view/:id"
        element={
          <AccessControl
            name={"Item Show"}
            auth={authUser}
            component={() => <ViewItem />}
          />
        }
      />
    </Route>
  );
}
